module.exports = __webpack_public_path__ + "img/2W.1.054e1373.jpg";